import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    errorGeocodingPlaces: translate({ id: 'gps.places.list.geocodingError' }),
  }))

  return api
}
